import ApplicationController from '../../application_controller'

// Follow/Unfollow button on the User Profile header -- same fetch + JSON-envelope
// contract as FollowersController#create/#cancel (pattern from user_connections_controller.js, no jQuery).
export default class extends ApplicationController {
  toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const url = button.dataset.url
    const method = (button.dataset.method || 'post').toUpperCase()
    // "post" == currently showing FOLLOW (about to follow); "put" == currently showing
    // UNFOLLOW (about to unfollow) -- used only to pick the right toast wording below.
    const wasFollowing = method === 'PUT'

    button.classList.add('disabled')
    button.style.pointerEvents = 'none'

    fetch(url, {
      method,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'X-CSRF-Token': this.getCsrfToken()
      }
    })
      .then(response => response.json().then(payload => ({ ok: response.ok, payload })))
      .then(({ ok, payload }) => {
        const link = ok && payload && payload.action && payload.action.link
        if (!link) throw new Error('Follow/unfollow request failed')

        if (link.url) button.dataset.url = link.url
        if (link.method) button.dataset.method = link.method
        if (link.text) this.applyState(button, link.text)

        window.Gv3Toast.success(wasFollowing ? 'You unfollowed this user.' : 'You are now following this user.')
      })
      .catch(error => {
        console.error('[FollowButton] action failed:', error)
        window.Gv3Toast.error('Something went wrong. Please try again.')
      })
      .finally(() => {
        button.classList.remove('disabled')
        button.style.pointerEvents = 'auto'
      })
  }

  // Sets label + brand-secondary(FOLLOW)/primary(UNFOLLOW) class -- ignores the server's
  // own classToggle value, which uses different class names than this page's convention.
  applyState(button, text) {
    button.textContent = text
    const isUnfollow = text.trim().toUpperCase() === 'UNFOLLOW'
    button.classList.toggle('btn-primary', isUnfollow)
    button.classList.toggle('btn-brand-secondary', !isUnfollow)
  }

  getCsrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }
}
